import React from "react";

import { StaticQuery, graphql } from "gatsby";

import SiteLayout from "./SiteLayout";

const TheLayout = ({ children }) => {
  return (
    <StaticQuery
      query={graphql`
        query {
          site {
            siteMetadata {
              title
            }
          }
        }
      `}
      render={data => {
        console.log(data);
        return <SiteLayout data={data}>{children}</SiteLayout>;
      }}
    />
  );
};

export default TheLayout;
